import { IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router-dom";
import { AMS_TAB_LABEL } from "./AmsTabs/hashFunctions";
import SchemaIcon from "@mui/icons-material/Schema";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";

/** @type {import('material-react-table').MRT_ColumnDef<AmsRow>[]} */
export const columns = [
  {
    accessorKey: "id",
    header: "ID",
    size: 80,
  },
  {
    accessorKey: "projectName",
    header: "Plant Name",
    size: 400,
  },
  {
    accessorKey: "smartPid",
    header: "Smart P&ID",
    size: 100,
    Cell: ({ row }) => (
      <Tooltip title="Open Smart P&ID">
        <IconButton
          component={Link}
          to={`/ams/${row.original.id}#${AMS_TAB_LABEL}=Smart P&ID`}
          rel="noopener noreferrer"
        >
          <SchemaIcon fontSize="medium" color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    accessorKey: "digital3DModel",
    header: "Digital 3D Model",
    size: 100,
    Cell: ({ row }) => (
      <Tooltip title="Open 3D Model">
        <IconButton
          component={Link}
          to={`/ams/${row.original.id}#${AMS_TAB_LABEL}=Digital 3D Modeling`}
          rel="noopener noreferrer"
        >
          <ViewInArIcon fontSize="medium" color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    accessorKey: "plm",
    header: "PLM",
    size: 100,
    Cell: ({ row }) => (
      <Tooltip title="Open PLM">
        <IconButton
          component={Link}
          to={`/ams/${row.original.id}#${AMS_TAB_LABEL}=PLM`}
          rel="noopener noreferrer"
        >
          <SettingsApplicationsIcon fontSize="medium" color="primary" />
        </IconButton>
      </Tooltip>
    ),
  },
];
